














import {Component, Vue, Watch} from 'vue-property-decorator'
import kepler from "../../lib/kepler_sdk/kepler";
@Component({
  components: { },

})

export default class InvoiceGallery extends Vue {

  //public show: boolean = true
  public pdfList:any = []
  public items:any = []
  public url:string =  ''
  public options = {
    page: 1,
    itemsPerPage: 20
  }
  public listSize= [10, 25, 50, 100]

  public headers:any=[
    {text: 'InvoiceID', value: 'id'},
    {text: 'InternalID', value: 'internal_id'},
    {text: 'Name', value: 'billing_info.organization_name'},
    {text: 'Date', value: 'emission_date', width: '110px'}
  ]
  public search:string = ''

  public loading = true

  public totalItems = null
  public totalPages = null

  public mounted() {
   // this.dataLoad()

  }


  public showInvoice(item:any, row:any) {
    row.select(true)
    this.url = item.url
  }
  @Watch('options', {deep: true})
  private dataLoad() {

    kepler.get('invoices', this.options)!.then((d) => {
      this.loading = false
      this.totalItems = d.data.items_count
      this.totalPages = d.data.page_count
      this.items = d.data.items

    })
  }



}
